module.exports = __webpack_public_path__ + "img/A3.120f47e6.jpg";